import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { brl } from "@/lib/format";
import { TrendingUp, TrendingDown, Users, ArrowRight, Info } from "@/components/icons";

const CARD = "bg-card rounded-2xl border border-black/5 p-4 shadow-[0_4px_20px_rgb(0,0,0,0.03)]";

function fmtHora(iso) {
  if (!iso) return null;
  try { return new Date(iso).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" }); } catch { return null; }
}

function DeltaTag({ atual, anterior }) {
  const a = Number(atual) || 0;
  const b = Number(anterior) || 0;
  if (b === 0) return null;
  const delta = ((a - b) / b) * 100;
  const up = delta >= 0;
  const Icon = up ? TrendingUp : TrendingDown;
  return (
    <span className={"inline-flex items-center gap-1 text-[11px] font-semibold px-1.5 py-0.5 rounded-md " + (up ? "text-emerald-700 bg-emerald-50" : "text-red-700 bg-red-50")}>
      <Icon className="w-3 h-3" />
      {up ? "+" : ""}{delta.toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%
    </span>
  );
}

export default function FaturamentoSankhyaCards() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const { data } = await api.get("/sankhya/faturamento/dashboard");
        if (!cancel) setD(data);
      } catch (e) { if (!cancel) setErr(e?.response?.data?.detail || "Sem dados"); }
    })();
    return () => { cancel = true; };
  }, []);

  if (err) return null; // silencioso — não polui a Início antes da Fase 2 ir ao ar
  if (!d) return null;
  // Set/2026: cards Sankhya na Início são exclusivos do Diretor Geral.
  // Vendedor/Gerente/Diretor veem o valor apenas no quadro azul de meta.
  // Admin (perfil técnico) não vê card algum de faturamento na Início.
  if (d.role !== "diretor_geral") return null;

  const hora = fmtHora(d.atualizado_em);
  const e = d.empresa || {};
  return (
    <section aria-label="Faturamento Sankhya" className="grid md:grid-cols-1 gap-3 mb-4" data-testid="dg-card-empresa">
      <Card data-testid="sk-empresa-mes" rot="Faturamento da empresa · mês atual" v={e.mes_atual?.liquido} sub={<span>Ano até hoje: <b>{brl(e.ano_ate_hoje?.liquido)}</b></span>} hora={hora} linkTo="/faturamento" />
    </section>
  );
}

function Card({ rot, v, sub, hora, linkTo, icon: Icon, ...rest }) {
  return (
    <Link to={linkTo || "#"} {...rest} className={CARD + " hover:shadow-md transition-shadow flex flex-col gap-2 group"}>
      <div className="flex items-center gap-2">
        {Icon && <Icon className="w-4 h-4 text-brand" />}
        <div className="text-xs uppercase tracking-wider text-muted-foreground font-semibold flex-1">{rot}</div>
        <ArrowRight className="w-4 h-4 text-slate-300 group-hover:text-brand transition-colors" />
      </div>
      <div className="text-2xl font-semibold text-navy">{brl(v || 0)}</div>
      {sub && <div className="flex items-center gap-2 flex-wrap text-xs text-muted-foreground">{sub}</div>}
      {hora && (
        <div className="flex items-center gap-1 text-[10px] text-slate-400 mt-auto">
          <Info className="w-3 h-3" /> Atualizado às {hora}
        </div>
      )}
    </Link>
  );
}
